var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"message"}},[_c('div',{class:("message message-" + _vm.type),domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }